export class ConfigDtoModel {

    public postXMLStartHour : number;
    public postXMLStartMin : number;
    public postXMLEndHour : number;
    public postXMLEndMin : number;
    public validNewsTimeInDays : number;
    public apiGroup : number ;
}
